module.exports = __webpack_public_path__ + "static/media/Banner4.616d2eff.png";